import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})

export class UniversityService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITIES(), data);
    }

    getUserUniversity(id, data): Observable<any> {
        return this.getRequest(AppUrl.USER_UNIVERSITIES(id), data);
    }

    count(): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITIES_COUNT());
    }

    detail(id): Observable<any> {
        return this.getRequestWithoutErrorMessage(AppUrl.UNIVERSITIES(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.UNIVERSITIES(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES(id), data);
    }

    updateProfile(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_PROFILE_IMAGE(id), data);
    }

    updatePassword(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_PASSWORD(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.UNIVERSITIES_STATUS(id), data);
    }

    detailByLanding(id): Observable<any> {
        return this.getRequest(AppUrl.UNIVERSITIES_LANDING(id));
    }
}
